export const stringToTime = (time: string) => {
    let hours = time.substring(0, 2);
    let minutes = time.substring(2, 4);
    // let seconds = time.substring(4, 6);
    return `${hours}:${minutes}`;
}